declare namespace $ {

	export class $mol_icon_tag_multiple extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=multiple.view.tree.d.ts.map